import React, { useEffect, useState } from "react";
//scrolling back to top
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

import Alert from "@material-ui/lab/Alert";
// I18n
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
// Router
import { useHistory } from "react-router-dom";
// MUI
import {
  Grid,
  Button,
  makeStyles,
  Typography,
  useScrollTrigger,
  Fab,
  Zoom,
  Toolbar,
} from "@material-ui/core";
// Components
import WorkerLogin from "./components/WorkerLogin";
import Authentication from "./components/Authentication";
import ApproveFor from "./components/Approve";
import CardLayout from "./components/CardLayout";
import {
  ADD_WORKER,
  INCOMPLETE_PUNCHES,
  MANAGE_ACTIVITY_GROUP,
  MANAGE_WORKERS,
  REPORTS,
  ALL_ACTIVITIES,
  ALL_HIGH_DURATION_ACTIVITIES,
  REVIEW,
  DASHBOARD_2,
} from "navigation/CONSTANTS";
import { useSelector, useDispatch } from "react-redux";
import PieChartCustom from "components/PieChartCustom";
import StackedBarChart from "components/StackedBarChart";
import { pieChartColors } from "../../config/index";

import {
  getActivityGroupReportData,
  getJobFamilyReportData,
  getClockedInReport,
  getHighDurationWorkerRecords,
} from "../../utils/report";
import { Link } from "react-router-dom";

import { getStartOfWeek, getEndOfWeek, properCase } from "../../utils/index";
import moment from "moment";
import {
  getManagerEmails,
  selectedManagerForApproval,
  selectedWorkerOnReview,
  selectedWeekOnReview,
  selectedMonthOnReport,
  selectedTeamOnReview,
  getCountries,
} from "redux/actions/appActions";
import { ITContractor, MY_TEAM } from "config/CONSTANTS";
import WeekPicker from "pages/Review/components/WeekPicker"; // mui-picker v3
import ClockedIn from "components/ClockedIn";
import HighDuration from "components/highDuration";
import LoaderView from "components/LoaderView";

const container = {
  marginTop: 20,
  marginBottom: 20,
};

const stackChartContainer = {
  // marginTop: 20,
  // marginBottom: 20,
};

const stackChartHeight = {
  height: "450px",
};

const useStyles = makeStyles((theme) => ({
  errorContent: {
    paddingLeft: 35,
    [theme.breakpoints.down("md")]: {
      paddingLeft: 0,
    },
  },
  content: {
    padding: theme.spacing(3),
  },
  root: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  leftBtn: { textAlign: "left" },
}));

function ScrollTop(props) {
  const { children } = props;
  const classes = useStyles();
  const trigger = useScrollTrigger();
  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );
    console.log("anchor", anchor);
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
}

export const HomeView = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();
  const addWorker = () => {
    history.push(ADD_WORKER);
  };
  const manageWorkers = () => {
    history.push(MANAGE_WORKERS, { isManageWorkers: true });
  };

  const manageActivityGroup = () => {
    history.push(MANAGE_ACTIVITY_GROUP, { isManageActivityGroup: true });
  };

  const gotoDashboard2 = () => {
    history.push(DASHBOARD_2);
  };

  const { isAuthenticated, user } = useSelector((state) => state.user.auth);

  const dispatch = useDispatch();
  const appConfig = useSelector((state) => state.appConfig);

  const [chart, setChart] = useState();
  const [highDurationchart, sethighDurationchart] = useState(null);
  const [jobFamilyChart, setJobFamilyChart] = useState();
  const [chartLoading, setChartLoading] = useState(true);
  const [highDurationchartLoading, sethighDurationchartLoading] =
    useState(true);
  const [jobFamilyChartLoadin, setJobFamilyChartLoading] = useState(true);
  const [clockedInReportDataLoading, setClockedInReportDataLoading] =
    useState(true);
  const isManager = isAuthenticated && user.isApprover && user.isActiveWorker;

  const [clockedInReportData, setClockedInReportData] = useState(null);
  const [mealEndLoader,setMealEndLoader] = useState(false);

  useEffect(()=>{
    document.title='IM Time'
  },[])
  useEffect(() => {
    console.log("user.workerId", user);
    const startDate = getStartOfWeek(new Date());
    const endDate = getEndOfWeek(startDate);

    console.log("WEEK SELECTION: weekStart: ", startDate);
    console.log("WEEK SELECTION: weekEnd: ", endDate);
    setChartLoading(true);
    setJobFamilyChartLoading(true);
    setClockedInReportDataLoading(true);
    sethighDurationchartLoading(true);
    console.log(
      "user worker Id",
      user.workerId,
      ":start date:",
      startDate,
      ":end Date:",
      endDate
    );
    if (user.workerId) {
      getActivityGroupReportData(user.workerId, startDate, endDate).then(
        (data) => {
          console.log("Activity Group report data", data);
          setChart(data);
          setChartLoading(false);
        }
      );

      const fromDate = moment()
        .subtract(2, "weeks")
        .startOf("week")
        .format("YYYY-MM-DD");
      const toDate = moment()
        .add(2, "weeks")
        .startOf("week")
        .format("YYYY-MM-DD");
      getHighDurationWorkerRecords(user.workerId, fromDate, toDate).then(
        (data) => {
          //console.log("Activity high duration Group report data", data);
          sethighDurationchart(data);
          sethighDurationchartLoading(false);
        }
      );

      console.log("hereeeeeee",startDate, endDate)
      getJobFamilyReportData(user.workerId, startDate, endDate).then((data) => {
        console.log("Job family report data", data);
        setJobFamilyChart(data);
        setJobFamilyChartLoading(false);
      });

      getClockedInReport(user.workerId, startDate, endDate).then((data) => {
        console.log("getClockedInReport data: ", data);
        setClockedInReportData(data);
        setClockedInReportDataLoading(false);
      });
    }

    if (appConfig !== null) {
      dispatch(getManagerEmails());
      dispatch(getCountries());
      dispatch(selectedManagerForApproval(null));
      dispatch(selectedWorkerOnReview({}));
      dispatch(selectedWeekOnReview(null));
      dispatch(selectedMonthOnReport(null));
      dispatch(selectedTeamOnReview({ team: MY_TEAM }));
    }
  }, [user]);

  const weekChangeHandler = (date) => {
    var weekStart = moment(date).format();
    var weekEnd = getEndOfWeek(weekStart);
    console.log("WEEK SELECTION: weekStart: ", weekStart);
    console.log("WEEK SELECTION: weekEnd: ", weekEnd);
    setChartLoading(true);
    setJobFamilyChartLoading(true);
    getActivityGroupReportData(user.workerId, weekStart, weekEnd).then(
      (data) => {
        console.log("Activity Group report data", data);
        setChart(data);
        setChartLoading(false);
      }
    );
    getJobFamilyReportData(user.workerId, weekStart, weekEnd).then((data) => {
      console.log("Job family report data", data);
      setJobFamilyChart(data);
      setJobFamilyChartLoading(false);
    });
  };

  const authMarkup = (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Grid container justify="center" alignItems="stretch" spacing={4}>
          <Grid item sm={4} xs={12}>
            <CardLayout title={properCase(t("pgHome.tlContingentWorkers"))}>
              <Grid container>
                {/* <Grid item xs={12}> */}
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    onClick={addWorker}
                    className={classes.leftBtn}
                  >
                    {t("pgHome.btnAddNewWorker")}
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    onClick={manageWorkers}
                    className={classes.leftBtn}
                  >
                    {t("pgHome.btnManageWorkers")}
                  </Button>
                </Grid>
                {/* <Grid item xs={6}>
                  <Button
                    color="primary"
                    onClick={manageActivityGroup}
                    className={classes.leftBtn}
                  >
                    {t("other.titleManageActivityGroup")}
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    onClick={() => history.push(INCOMPLETE_PUNCHES)}
                    className={classes.leftBtn}
                  >
                    {t("other.lblIncompleteActivities")}
                  </Button>
                </Grid> */}
                {/* </Grid> */}
              </Grid>
            </CardLayout>
          </Grid>
          {isManager && (
            <Grid item sm={4} xs={12}>
              <ApproveFor />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );

  return (
    <LoaderView loading={mealEndLoader} >
    <main className={classes.content}>
      
      {/* <Button onClick={gotoDashboard2}>Go to Dashboard 2.0 </Button> */}
      <Toolbar style={{ minHeight: "0" }} id="back-to-top-anchor"></Toolbar>
      
      <Grid container spacing={3}>
        {/* <Grid item xs={12}>
          <Grid container justify="center" alignItems="stretch" spacing={4}>
            <Grid item sm={4} xs={12}>
              <WorkerLogin />
            </Grid>

            {(!isAuthenticated || isManager) && (
              <Grid item sm={4} xs={12}>
                <Authentication />
              </Grid>
            )}
          </Grid>
          {isManager && authMarkup}
        </Grid> */}
        
        <Grid item xs={12}>
          {!isManager ? (
            <Grid container justify="center" alignItems="stretch" spacing={4}>
              <Grid item sm={4} xs={12}>
                <WorkerLogin setMealEndLoader={setMealEndLoader}/>
              </Grid>

              {(!isAuthenticated || isManager || (user.jobType && user.jobType === ITContractor)) && (
                <Grid item sm={4} xs={12}>
                  <Authentication />
                </Grid>
              )}
            </Grid>
          ) : (
            <Grid container justify="center" alignItems="stretch" spacing={2}>
              <Grid item sm={2} xs={12}>
                <WorkerLogin setMealEndLoader={setMealEndLoader} />
              </Grid>
              <Grid item sm={4} xs={12}>
                {(!isAuthenticated || isManager) && <Authentication />}
              </Grid>

              <Grid item sm={2} xs={12}>
                {isManager && <ApproveFor />}
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>

      {isManager && (
        <>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container justify="center" alignItems="stretch" spacing={4}>
                <Grid item xs={12} sm={8}>
                  <CardLayout title={t("pgHome.lblClockedIn")}>
                    <LoaderView loading={clockedInReportDataLoading}>
                      <ClockedIn data={clockedInReportData} />
                    </LoaderView>
                  </CardLayout>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
      {isManager && (
        <>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container justify="center" alignItems="stretch" spacing={4}>
                <Grid item xs={12} sm={8}>
                  <Link
                    to={{
                      pathname: ALL_HIGH_DURATION_ACTIVITIES,
                      state: {
                        isHighDuration: true,
                        dataProp: highDurationchart,
                      },
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <CardLayout title={properCase(t("other.HighDuration"))}>
                      <LoaderView loading={highDurationchartLoading}>
                        {highDurationchart && highDurationchart.length > 0 ? (
                          <HighDuration data={highDurationchart} />
                        ) : (
                          <Grid xs={12} justify="center">
                            <Typography
                              variant="caption"
                              className={classes.errorContent}
                            >
                              {/* {t("pgHome.errNoReportData")} */}
                              <Alert severity="info">
                                {t("pgHome.errNoReportData")}
                              </Alert>
                            </Typography>
                          </Grid>
                        )}
                      </LoaderView>
                    </CardLayout>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container justify="center" alignItems="stretch" spacing={4}>
                <Grid item xs={12} sm={8}>
                  <CardLayout title={properCase(t("pgHome.report1"))}>
                    <LoaderView loading={chartLoading}>
                      <Grid container direction="row" justify="center">
                        <Grid xs={12}>
                          <WeekPicker
                            lbl={properCase(t("pgHome.lblReportWeek"))}
                            weekChangeHandler={weekChangeHandler}
                            minDate={moment(new Date()).subtract(2, "weeks")}
                            maxDate={new Date()}
                          />
                        </Grid>
                        {chart && chart.length > 0 ? (
                          <Grid justify="center">
                            <Link
                              to={{
                                pathname: REPORTS,
                                state: { isReportView: true },
                              }}
                              style={{ textDecoration: "none" }}
                            >
                              <PieChartCustom
                                data={chart}
                                colors={pieChartColors}
                                width={600}
                                height={250}
                              ></PieChartCustom>
                            </Link>
                          </Grid>
                        ) : (
                          <>
                            <Grid xs={12} justify="center">
                              <Typography
                                variant="caption"
                                className={classes.errorContent}
                              >
                                {/* {t("pgHome.errNoReportData")} */}
                                <Alert severity="info">
                                  {t("pgHome.errNoReportData")}
                                </Alert>
                              </Typography>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </LoaderView>
                  </CardLayout>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}

      {isManager && (
        //new code
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid
              container
              justify="center"
              alignItems="stretch"
              spacing={4}
              style={stackChartContainer}
            >
              <Grid item sm={8} xs={12}>
                <Link
                  to={{ pathname: REPORTS, state: { isReportView: true } }}
                  style={{ textDecoration: "none" }}
                >
                  <CardLayout title={properCase(t("pgHome.report2"))}>
                    <LoaderView loading={jobFamilyChartLoadin}>
                      <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="center"
                      >
                        {jobFamilyChart && jobFamilyChart.length > 0 ? (
                          <Grid xs={12} style={stackChartHeight}>
                            <StackedBarChart
                              data={jobFamilyChart}
                              xAxisDataKey="_"
                              barDataKey1="Transactional"
                              bar1Color="#1B75BC"
                              barDataKey2="Non-Transactional"
                              bar2Color="#00A88E"
                              barDataKey3="Project"
                              bar3Color="#6DCFF6"
                            ></StackedBarChart>
                          </Grid>
                        ) : (
                          <>
                            <Grid xs={12} justify="center">
                              <Typography
                                variant="caption"
                                className={classes.errorContent}
                              >
                                {/* {t("pgHome.errNoReportData")} */}
                                <Alert severity="info">
                                  {t("pgHome.errNoReportData")}
                                </Alert>
                              </Typography>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </LoaderView>
                  </CardLayout>
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      <ScrollTop {...props}>
        <Fab color="primary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </main>
    </LoaderView>
  );
};

export default HomeView;
